import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from '@/lib/format';

interface PortfolioPerformance {
  portfolio_id: string;
  portfolio_name: string;
  last_valuation_at: string | null;
  last_irr: number | null;
  last_npv: number | null;
  lifetime_collections: number;
  nominal_value: number | null;
}

interface PortfolioPerformanceTableProps {
  data: PortfolioPerformance[];
}

export const PortfolioPerformanceTable = ({ data }: PortfolioPerformanceTableProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Portfolio Performance</CardTitle>
        <CardDescription>
          Analytics mart showing portfolio valuations and collections
        </CardDescription>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-8">
            No portfolio performance data available. Run ETL jobs to populate the data warehouse.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Portfolio</TableHead>
                <TableHead>Last Valuation</TableHead>
                <TableHead className="text-right">IRR</TableHead>
                <TableHead className="text-right">NPV</TableHead>
                <TableHead className="text-right">Lifetime Collections</TableHead>
                <TableHead className="text-right">Nominal Value</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((portfolio) => (
                <TableRow key={portfolio.portfolio_id}>
                  <TableCell className="font-medium">{portfolio.portfolio_name}</TableCell>
                  <TableCell>
                    {portfolio.last_valuation_at
                      ? new Date(portfolio.last_valuation_at).toLocaleDateString()
                      : 'Never'}
                  </TableCell>
                  <TableCell className="text-right">
                    {portfolio.last_irr != null ? `${(portfolio.last_irr * 100).toFixed(2)}%` : '-'}
                  </TableCell>
                  <TableCell className="text-right">
                    {portfolio.last_npv != null ? formatCurrency(portfolio.last_npv) : '-'}
                  </TableCell>
                  <TableCell className="text-right">
                    {formatCurrency(portfolio.lifetime_collections)}
                  </TableCell>
                  <TableCell className="text-right">
                    {portfolio.nominal_value != null ? formatCurrency(portfolio.nominal_value) : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
